import CompareMixin from '../components/filters/compare-mixin'
import { filters } from '../constants'
import { normalizeSettingsForShowAll } from './shared'

export const companyGroupsDefinition = {
  type: filters.COMPANY_GROUPS,
  nameKey: 'company_groups',
  ledgerRequired: false,

  shouldShow() {
    return window.Silverfin.currentContractFeatures?.supports_groups
  },

  activeSubtitle(settings, getters) {
    if (settings.comparisonMode === CompareMixin.TYPES.SHOW_ALL) {
      return I18n.t('companies_overview.filters.comparison_modes.show_all')
    }

    const group = getters.getFilterDropdownValueLabel(
      'groups',
      parseInt(settings.comparisonValue)
    )

    return group || ''
  },

  normalizeSettings(settings) {
    return normalizeSettingsForShowAll(settings, 'comparisonValue')
  },

  serializeSettings(settings) {
    return {
      comparison_mode: settings.comparisonMode,
      comparison_value: settings.comparisonValue,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      comparisonValue: params.comparison_value,
    }
  },
}
